import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { cloneElement, useContext } from "react";
import { Colors } from "@zapier/design-system";
import { NudgeImage, NudgeLayout } from "@zapier/upsells/esm/components";
import { UpgradeModalContext } from "@zapier/upsells/esm/contexts";
import { upgradeReasons } from "@zapier/upsells/esm/types";
import { getActiveView } from "./getActiveView";
const CloseModalOnClick = ({ children, onClose }) => cloneElement(children, {
    onClick: onClose,
});
export const TaskLimitLowUpgradeNudge = ({ onClose }) => {
    const { account, accountCurrency, autoUpgradeToPlan, destinationPlan, isAutoUpgradeEnabled, isLoading, } = useContext(UpgradeModalContext);
    const activeView = !isLoading && (account === null || account === void 0 ? void 0 : account.plan) && destinationPlan
        ? getActiveView({
            autoUpgradeToPlan,
            currency: accountCurrency,
            currentPlan: account === null || account === void 0 ? void 0 : account.plan,
            destinationPlan,
            isAutoUpgradeEnabled,
        })
        : null;
    return (_jsx(NudgeLayout, { bodyText: activeView === null || activeView === void 0 ? void 0 : activeView.bodyText, buttons: activeView
            ? activeView.buttons.map((button, key) => (_jsx(CloseModalOnClick, { onClose: onClose, children: button }, key)))
            : null, headingText: "You're running low on tasks", id: "tasks-low", image: _jsx(NudgeImage, { type: upgradeReasons.taskLimitLow }), imageBackgroundColor: Colors.warning100 }));
};

// @zapier/upsells@8.0.3 (1de7a616e)
